
import Vue from 'vue';
import CardSkeleton from './atoms/CardSkeleton.vue';
import LineSkeleton from './atoms/LineSkeleton.vue';
import Constants from '@/settings/ui';

export default Vue.extend({
  components: {
    LineSkeleton,
    CardSkeleton,
  },
  data() {
    return {
      white: Constants.colorPalette.white,
    };
  },
});
